import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";

import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";

export type FormImageViewerProps = CustomComponentProps & {
    images: File[];
    isReply?: boolean;
    removeImg: (img: File) => void;
};

const FormImageViewer = ({
    images,
    removeImg,
    isReply = false,
    className,
    style
}: FormImageViewerProps) => {
    const responsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 1024
            },
            items: 2,
            partialVisibilityGutter: 40
        },
        mobile: {
            breakpoint: {
                max: 576,
                min: 0
            },
            items: 2
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 576
            },
            items: 2,
            partialVisibilityGutter: 30
        }
    };

    return (
        <div
            className={`img-displayer post-media-displayer d-flex flex-j-start flex-a-end gap-5 flex-wrap ${className}`}
            style={style}
        >
            {!isReply ? (
                <Carousel
                    additionalTransfrom={0}
                    arrows
                    autoPlaySpeed={300000000}
                    centerMode={true}
                    className=""
                    containerClass="container"
                    dotListClass=""
                    draggable
                    focusOnSelect={false}
                    infinite={false}
                    itemClass=""
                    keyBoardControl
                    minimumTouchDrag={80}
                    pauseOnHover
                    renderArrowsWhenDisabled={false}
                    renderButtonGroupOutside={false}
                    renderDotsOutside={false}
                    responsive={responsive}
                    rewind={false}
                    rewindWithAnimation={false}
                    rtl={false}
                    shouldResetAutoplay
                    showDots={false}
                    sliderClass=""
                    slidesToSlide={1}
                    swipeable
                >
                    {images.map((img) => (
                        <div
                            className="post-form-img-container p-relative"
                            key={img.name}
                        >
                            <img src={URL.createObjectURL(img)} alt="" />
                            <div className="close-wrap">
                                <span
                                    className="custom-close-modal"
                                    onClick={() => removeImg(img)}
                                >
                                    <SVG svg="x" size={16} />
                                </span>
                            </div>
                        </div>
                    ))}
                </Carousel>
            ) : (
                <>
                    {images.map((img) => (
                        <div
                            className="post-form-img-container p-relative"
                            key={img.name}
                        >
                            <img src={URL.createObjectURL(img)} alt="" />
                            <div className="close-wrap">
                                <span
                                    className="custom-close-modal"
                                    onClick={() => removeImg(img)}
                                >
                                    <SVG svg="x" size={16} />
                                </span>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default FormImageViewer;
